// @flow
export const MODEL = 'Supplies'
export const TREE = 'suppliesData'
export const BRANCH = 'supplies'

export const URL = '/hefty/supplies/'


// Model Attributes
export const PROP_ID = 'id'
export const PROP_SUPPLY_ID = PROP_ID
export const PROP_NAME = 'name'
export const PROP_DESCRIPTION = 'description'
export const PROP_NOTES = 'notes'
export const PROP_BASE_PRICE = 'base_price'
export const PROP_QUANTITY_PRICE = 'quantity_price'
export const PROP_TAXABLE = 'taxable'
export const PROP_IMAGE = 'image'
